/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
//     SourceSHA: 
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { TellerOnlineApiClientBase } from 'teller-online-libraries/core';
import { TellerOnlineWindowService } from "teller-online-libraries/shared";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const PAYMENT_INTEGRATIONS_API_BASE_URL = new InjectionToken<string>('PAYMENT_INTEGRATIONS_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class SharedPaymentIntegrationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return SharedPaymentIntegrationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYMENT_INTEGRATIONS_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) SharedPaymentIntegrationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/payment-integrations";
    }

    static init(baseUrl: string){
        SharedPaymentIntegrationApiClient._baseUrl = baseUrl;
    }

    /**
     * @return OK
     */
    getConfig(): Observable<PaymentConfigResponseDto> {
        let url_ = this.baseUrl + "/config";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetConfig(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetConfig(<any>r));
                } catch (e) {
                    return <Observable<PaymentConfigResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentConfigResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<PaymentConfigResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentConfigResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a hash value of this cart to determine if it has been modified in the context of what's sent to the payment processor
     * @param paymentMethodType The payment method being used
     * @param cartGuid Unique GUID of cart
     * @param paymentIdentifier (optional) Unique payment identifier for this cart to use in the hashing check
     * @return OK
     */
    getCartHash(paymentMethodType: string, cartGuid: string, paymentIdentifier?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/cart-hash/{CartGuid}/{PaymentMethodType}?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentMethodType === undefined || paymentMethodType === null)
            throw new Error("The parameter 'paymentMethodType' must be defined.");
        url_ = url_.replace("{PaymentMethodType}", encodeURIComponent("" + paymentMethodType));
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (paymentIdentifier !== undefined && paymentIdentifier !== null)
            url_ += "PaymentIdentifier=" + encodeURIComponent("" + paymentIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCartHash(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCartHash(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetCartHash(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : _responseText;
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    verifyPaymentStatus(body: RedirectVerifyPaymentStatusRequestDto): Observable<RedirectVerifyPaymentStatusResponseDto> {
        let url_ = this.baseUrl + "/verifyPaymentStatus";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processVerifyPaymentStatus(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processVerifyPaymentStatus(<any>r));
                } catch (e) {
                    return <Observable<RedirectVerifyPaymentStatusResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RedirectVerifyPaymentStatusResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyPaymentStatus(response: HttpResponseBase): Observable<RedirectVerifyPaymentStatusResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedirectVerifyPaymentStatusResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cartGuid Unique identifier for the cart
     * @param paymentStatus (optional) Desired status of the returned payment
     * @return OK
     */
    startPayment(cartGuid: string, paymentStatus?: PaymentStatusEnumDto | undefined): Observable<StartPaymentResponseDto> {
        let url_ = this.baseUrl + "/start-payment/{CartGuid}?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (paymentStatus === null)
            throw new Error("The parameter 'paymentStatus' cannot be null.");
        else if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processStartPayment(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processStartPayment(<any>r));
                } catch (e) {
                    return <Observable<StartPaymentResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StartPaymentResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processStartPayment(response: HttpResponseBase): Observable<StartPaymentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartPaymentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    makePayment(body: IFramePaymentRequestDto): Observable<IFramePaymentResponseDto> {
        let url_ = this.baseUrl + "/payment";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processMakePayment(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processMakePayment(<any>r));
                } catch (e) {
                    return <Observable<IFramePaymentResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFramePaymentResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processMakePayment(response: HttpResponseBase): Observable<IFramePaymentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFramePaymentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentMethodId Unique ID of the payment method to update
     * @return OK
     */
    updatePaymentMethod(paymentMethodId: number, body: IFrameSavePaymentMethodRequestDto): Observable<IFrameSavePaymentMethodResponseDto> {
        let url_ = this.baseUrl + "/update-payment-method/{PaymentMethodId}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentMethodId === undefined || paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' must be defined.");
        url_ = url_.replace("{PaymentMethodId}", encodeURIComponent("" + paymentMethodId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdatePaymentMethod(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdatePaymentMethod(<any>r));
                } catch (e) {
                    return <Observable<IFrameSavePaymentMethodResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFrameSavePaymentMethodResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePaymentMethod(response: HttpResponseBase): Observable<IFrameSavePaymentMethodResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFrameSavePaymentMethodResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    addPaymentMethod(body: IFrameSavePaymentMethodRequestDto): Observable<IFrameSavePaymentMethodResponseDto> {
        let url_ = this.baseUrl + "/add-payment-method";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddPaymentMethod(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddPaymentMethod(<any>r));
                } catch (e) {
                    return <Observable<IFrameSavePaymentMethodResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFrameSavePaymentMethodResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddPaymentMethod(response: HttpResponseBase): Observable<IFrameSavePaymentMethodResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFrameSavePaymentMethodResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cartGuid Unique GUID of cart
     * @param paymentMethodType The payment method being used
     * @return OK
     */
    calculateConvenienceFee(cartGuid: string, paymentMethodType: string): Observable<ConvenienceFeeResponseDto> {
        let url_ = this.baseUrl + "/convenience-fee/{CartGuid}/{PaymentMethodType}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (paymentMethodType === undefined || paymentMethodType === null)
            throw new Error("The parameter 'paymentMethodType' must be defined.");
        url_ = url_.replace("{PaymentMethodType}", encodeURIComponent("" + paymentMethodType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCalculateConvenienceFee(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCalculateConvenienceFee(<any>r));
                } catch (e) {
                    return <Observable<ConvenienceFeeResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConvenienceFeeResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCalculateConvenienceFee(response: HttpResponseBase): Observable<ConvenienceFeeResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConvenienceFeeResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cartGuid Unique Identifier for the cart
     * @return OK
     */
    getRedirectUrl(cartGuid: string): Observable<string> {
        let url_ = this.baseUrl + "/getRedirectUrl/{CartGuid}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRedirectUrl(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRedirectUrl(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetRedirectUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : _responseText;
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NicIntegrationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return NicIntegrationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYMENT_INTEGRATIONS_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) NicIntegrationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/payment-integrations";
    }

    static init(baseUrl: string){
        NicIntegrationApiClient._baseUrl = baseUrl;
    }

    /**
     * @return OK
     */
    nicVerifyPaymentStatus(body: NicVerifyPaymentStatusRequestDto): Observable<NicVerifyPaymentStatusResponseDto> {
        let url_ = this.baseUrl + "/nic/verifyPaymentStatus";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processNicVerifyPaymentStatus(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processNicVerifyPaymentStatus(<any>r));
                } catch (e) {
                    return <Observable<NicVerifyPaymentStatusResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NicVerifyPaymentStatusResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processNicVerifyPaymentStatus(response: HttpResponseBase): Observable<NicVerifyPaymentStatusResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NicVerifyPaymentStatusResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ElavonIntegrationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return ElavonIntegrationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYMENT_INTEGRATIONS_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) ElavonIntegrationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/payment-integrations";
    }

    static init(baseUrl: string){
        ElavonIntegrationApiClient._baseUrl = baseUrl;
    }

    /**
     * @return OK
     */
    requestSessionToken(): Observable<SessionTokenResponseDto> {
        let url_ = this.baseUrl + "/elavon/requestSessionToken";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRequestSessionToken(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRequestSessionToken(<any>r));
                } catch (e) {
                    return <Observable<SessionTokenResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SessionTokenResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processRequestSessionToken(response: HttpResponseBase): Observable<SessionTokenResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionTokenResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CyberSourceIntegrationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return CyberSourceIntegrationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYMENT_INTEGRATIONS_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) CyberSourceIntegrationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/payment-integrations";
    }

    static init(baseUrl: string){
        CyberSourceIntegrationApiClient._baseUrl = baseUrl;
    }

    /**
     * @return OK
     */
    getSessionToken(): Observable<SessionTokenResponseDto> {
        let url_ = this.baseUrl + "/cyber-source/requestSessionToken";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSessionToken(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSessionToken(<any>r));
                } catch (e) {
                    return <Observable<SessionTokenResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SessionTokenResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSessionToken(response: HttpResponseBase): Observable<SessionTokenResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionTokenResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FisIntegrationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return FisIntegrationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYMENT_INTEGRATIONS_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) FisIntegrationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/payment-integrations";
    }

    static init(baseUrl: string){
        FisIntegrationApiClient._baseUrl = baseUrl;
    }

    /**
     * @param paymentMethodType The selected payment method type
     * @param forMultiPay Whether or not we need a jwt for multipay
     * @return OK
     */
    requestJwt(paymentMethodType: string, forMultiPay: boolean): Observable<SessionTokenResponseDto> {
        let url_ = this.baseUrl + "/fis/requestJwt/{PaymentMethodType}?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentMethodType === undefined || paymentMethodType === null)
            throw new Error("The parameter 'paymentMethodType' must be defined.");
        url_ = url_.replace("{PaymentMethodType}", encodeURIComponent("" + paymentMethodType));
        if (forMultiPay === undefined || forMultiPay === null)
            throw new Error("The parameter 'forMultiPay' must be defined and cannot be null.");
        else
            url_ += "ForMultiPay=" + encodeURIComponent("" + forMultiPay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRequestJwt(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRequestJwt(<any>r));
                } catch (e) {
                    return <Observable<SessionTokenResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SessionTokenResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processRequestJwt(response: HttpResponseBase): Observable<SessionTokenResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionTokenResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    preparePaymentAndAssessFees(body: IFramePaymentRequestDto): Observable<IFramePaymentPrepareResponseDto> {
        let url_ = this.baseUrl + "/fis/preparePaymentAndAssessFees";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPreparePaymentAndAssessFees(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPreparePaymentAndAssessFees(<any>r));
                } catch (e) {
                    return <Observable<IFramePaymentPrepareResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFramePaymentPrepareResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processPreparePaymentAndAssessFees(response: HttpResponseBase): Observable<IFramePaymentPrepareResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFramePaymentPrepareResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    fisGeneratePaymentDetails(body: FisPaymentDetailsRequestDto): Observable<FisPaymentDetailsResponseDto> {
        let url_ = this.baseUrl + "/fis/generatePaymentDetails";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processFisGeneratePaymentDetails(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFisGeneratePaymentDetails(<any>r));
                } catch (e) {
                    return <Observable<FisPaymentDetailsResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FisPaymentDetailsResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processFisGeneratePaymentDetails(response: HttpResponseBase): Observable<FisPaymentDetailsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FisPaymentDetailsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    fisVerifyPayment(body: FisVerifyPaymentRequestDto): Observable<IFramePaymentResponseDto> {
        let url_ = this.baseUrl + "/fis/verifyPayment";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processFisVerifyPayment(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFisVerifyPayment(<any>r));
                } catch (e) {
                    return <Observable<IFramePaymentResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFramePaymentResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processFisVerifyPayment(response: HttpResponseBase): Observable<IFramePaymentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFramePaymentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class IFramePaymentRequestDto implements IIFramePaymentRequestDto {
    /** Unique ID of the cart being paid */
    cartId!: number;
    /** The token provided by the reCAPTCHA widget */
    captchaToken?: string | undefined;
    paymentMethodType!: PaymentMethodTypeEnumDto;
    /** Last 4 digits of card being used to pay */
    last4?: string;
    /** Visa, Mastercard, Discover, or Amex */
    cardType?: string;
    eCheckAccountType?: ECheckAccountTypeEnumDto;
    eCheckAccountOwnerType?: ECheckAccountOwnerTypeEnumDto;
    /** E-Check Account Number */
    eCheckAccountNumber?: string;
    /** E-Check Routing Number */
    eCheckRoutingNumber?: string;
    /** Month/Year of expiry */
    cardExpiry?: string;
    /** Full name */
    fullName?: string;
    /** Line 1 of the billing address fields */
    addressLine1?: string;
    /** Line 2 of the billing address fields */
    addressLine2?: string;
    /** Billing Address city */
    addressCity?: string;
    /** Billing Address state */
    addressState?: string;
    /** Billing address state code */
    addressStateCode?: string;
    /** Billing zip code */
    addressZip?: string;
    /** Billing address country */
    addressCountry?: string;
    /** Billing address ISO country code */
    addressCountryCode?: string;
    /** Address Phone number (e.g. (973) 552-2630) */
    phone?: string;
    /** CC Token */
    token?: string;
    /** If present this will trigger a test scenario with the payment processor if IsTestEnvironment = true */
    paymentProcessorTestTrigger?: string;
    /** The ID of the inbound redirect source where the request was initiated, if any. */
    inboundRedirectSourceId?: number;
    /** An additional token that must be included in order to successfully submit a payment. Likely the result of a previous call to the processor. Not needed for most processors. */
    validationToken?: string;
    /** The payment method type code returned to the processor. */
    processorPaymentMethodType?: string;

    [key: string]: any;

    constructor(data?: IIFramePaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cartId = _data["cartId"];
            this.captchaToken = _data["captchaToken"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.last4 = _data["last4"];
            this.cardType = _data["cardType"];
            this.eCheckAccountType = _data["eCheckAccountType"];
            this.eCheckAccountOwnerType = _data["eCheckAccountOwnerType"];
            this.eCheckAccountNumber = _data["eCheckAccountNumber"];
            this.eCheckRoutingNumber = _data["eCheckRoutingNumber"];
            this.cardExpiry = _data["cardExpiry"];
            this.fullName = _data["fullName"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressCity = _data["addressCity"];
            this.addressState = _data["addressState"];
            this.addressStateCode = _data["addressStateCode"];
            this.addressZip = _data["addressZip"];
            this.addressCountry = _data["addressCountry"];
            this.addressCountryCode = _data["addressCountryCode"];
            this.phone = _data["phone"];
            this.token = _data["token"];
            this.paymentProcessorTestTrigger = _data["paymentProcessorTestTrigger"];
            this.inboundRedirectSourceId = _data["inboundRedirectSourceId"];
            this.validationToken = _data["validationToken"];
            this.processorPaymentMethodType = _data["processorPaymentMethodType"];
        }
    }

    static fromJS(data: any): IFramePaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new IFramePaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cartId"] = this.cartId;
        data["captchaToken"] = this.captchaToken;
        data["paymentMethodType"] = this.paymentMethodType;
        data["last4"] = this.last4;
        data["cardType"] = this.cardType;
        data["eCheckAccountType"] = this.eCheckAccountType;
        data["eCheckAccountOwnerType"] = this.eCheckAccountOwnerType;
        data["eCheckAccountNumber"] = this.eCheckAccountNumber;
        data["eCheckRoutingNumber"] = this.eCheckRoutingNumber;
        data["cardExpiry"] = this.cardExpiry;
        data["fullName"] = this.fullName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressCity"] = this.addressCity;
        data["addressState"] = this.addressState;
        data["addressStateCode"] = this.addressStateCode;
        data["addressZip"] = this.addressZip;
        data["addressCountry"] = this.addressCountry;
        data["addressCountryCode"] = this.addressCountryCode;
        data["phone"] = this.phone;
        data["token"] = this.token;
        data["paymentProcessorTestTrigger"] = this.paymentProcessorTestTrigger;
        data["inboundRedirectSourceId"] = this.inboundRedirectSourceId;
        data["validationToken"] = this.validationToken;
        data["processorPaymentMethodType"] = this.processorPaymentMethodType;
        return data;
    }
}

export interface IIFramePaymentRequestDto {
    /** Unique ID of the cart being paid */
    cartId: number;
    /** The token provided by the reCAPTCHA widget */
    captchaToken?: string | undefined;
    paymentMethodType: PaymentMethodTypeEnumDto;
    /** Last 4 digits of card being used to pay */
    last4?: string;
    /** Visa, Mastercard, Discover, or Amex */
    cardType?: string;
    eCheckAccountType?: ECheckAccountTypeEnumDto;
    eCheckAccountOwnerType?: ECheckAccountOwnerTypeEnumDto;
    /** E-Check Account Number */
    eCheckAccountNumber?: string;
    /** E-Check Routing Number */
    eCheckRoutingNumber?: string;
    /** Month/Year of expiry */
    cardExpiry?: string;
    /** Full name */
    fullName?: string;
    /** Line 1 of the billing address fields */
    addressLine1?: string;
    /** Line 2 of the billing address fields */
    addressLine2?: string;
    /** Billing Address city */
    addressCity?: string;
    /** Billing Address state */
    addressState?: string;
    /** Billing address state code */
    addressStateCode?: string;
    /** Billing zip code */
    addressZip?: string;
    /** Billing address country */
    addressCountry?: string;
    /** Billing address ISO country code */
    addressCountryCode?: string;
    /** Address Phone number (e.g. (973) 552-2630) */
    phone?: string;
    /** CC Token */
    token?: string;
    /** If present this will trigger a test scenario with the payment processor if IsTestEnvironment = true */
    paymentProcessorTestTrigger?: string;
    /** The ID of the inbound redirect source where the request was initiated, if any. */
    inboundRedirectSourceId?: number;
    /** An additional token that must be included in order to successfully submit a payment. Likely the result of a previous call to the processor. Not needed for most processors. */
    validationToken?: string;
    /** The payment method type code returned to the processor. */
    processorPaymentMethodType?: string;

    [key: string]: any;
}

/** Response to posting a payment */
export class IFramePaymentResponseDto implements IIFramePaymentResponseDto {
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    /** True if the payment succeeded, false otherwise */
    responseSuccess?: any;
    /** The error message corresponding to a failed payment */
    responseMessage?: string;
    /** Tracking number provided by payment processor upon completion of successful payment. */
    processorTrackingId?: string;

    [key: string]: any;

    constructor(data?: IIFramePaymentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.emailAddress = _data["emailAddress"];
            this.responseSuccess = _data["responseSuccess"];
            this.responseMessage = _data["responseMessage"];
            this.processorTrackingId = _data["processorTrackingId"];
        }
    }

    static fromJS(data: any): IFramePaymentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IFramePaymentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["emailAddress"] = this.emailAddress;
        data["responseSuccess"] = this.responseSuccess;
        data["responseMessage"] = this.responseMessage;
        data["processorTrackingId"] = this.processorTrackingId;
        return data;
    }
}

/** Response to posting a payment */
export interface IIFramePaymentResponseDto {
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    /** True if the payment succeeded, false otherwise */
    responseSuccess?: any;
    /** The error message corresponding to a failed payment */
    responseMessage?: string;
    /** Tracking number provided by payment processor upon completion of successful payment. */
    processorTrackingId?: string;

    [key: string]: any;
}

export class IFrameSavePaymentMethodRequestDto implements IIFrameSavePaymentMethodRequestDto {
    /** The token provided by the recaptcha widget */
    captchaToken?: string | undefined;
    /** Last 4 digits of card being used to pay */
    last4?: string;
    /** Visa, Mastercard, Discover, or Amex */
    cardType?: string;
    /** When the card expires (MMYY) */
    cardExpiry?: string;
    eCheckAccountType?: ECheckAccountTypeEnumDto;
    eCheckAccountOwnerType?: ECheckAccountOwnerTypeEnumDto;
    /** E-Check Account Number */
    eCheckAccountNumber?: string;
    /** E-Check Routing Number */
    eCheckRoutingNumber?: string;
    /** Full name */
    fullName?: string;
    /** Line 1 of the billing address fields */
    addressLine1?: string;
    /** Line 2 of the billing address fields */
    addressLine2?: string;
    /** Billing Address city */
    addressCity?: string;
    /** Billing Address state */
    addressState?: string;
    /** Billing address state code */
    addressStateCode?: string;
    /** Billing zip code */
    addressZip?: string;
    /** Billing address country */
    addressCountry?: string;
    /** Billing address ISO country code */
    addressCountryCode?: string;
    /** Address Phone number (e.g. (973) 552-2630) */
    phone?: string;
    /** CC Token */
    token?: string;
    paymentMethodType!: PaymentMethodTypeEnumDto;

    [key: string]: any;

    constructor(data?: IIFrameSavePaymentMethodRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.captchaToken = _data["captchaToken"];
            this.last4 = _data["last4"];
            this.cardType = _data["cardType"];
            this.cardExpiry = _data["cardExpiry"];
            this.eCheckAccountType = _data["eCheckAccountType"];
            this.eCheckAccountOwnerType = _data["eCheckAccountOwnerType"];
            this.eCheckAccountNumber = _data["eCheckAccountNumber"];
            this.eCheckRoutingNumber = _data["eCheckRoutingNumber"];
            this.fullName = _data["fullName"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressCity = _data["addressCity"];
            this.addressState = _data["addressState"];
            this.addressStateCode = _data["addressStateCode"];
            this.addressZip = _data["addressZip"];
            this.addressCountry = _data["addressCountry"];
            this.addressCountryCode = _data["addressCountryCode"];
            this.phone = _data["phone"];
            this.token = _data["token"];
            this.paymentMethodType = _data["PaymentMethodType"];
        }
    }

    static fromJS(data: any): IFrameSavePaymentMethodRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new IFrameSavePaymentMethodRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["captchaToken"] = this.captchaToken;
        data["last4"] = this.last4;
        data["cardType"] = this.cardType;
        data["cardExpiry"] = this.cardExpiry;
        data["eCheckAccountType"] = this.eCheckAccountType;
        data["eCheckAccountOwnerType"] = this.eCheckAccountOwnerType;
        data["eCheckAccountNumber"] = this.eCheckAccountNumber;
        data["eCheckRoutingNumber"] = this.eCheckRoutingNumber;
        data["fullName"] = this.fullName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressCity"] = this.addressCity;
        data["addressState"] = this.addressState;
        data["addressStateCode"] = this.addressStateCode;
        data["addressZip"] = this.addressZip;
        data["addressCountry"] = this.addressCountry;
        data["addressCountryCode"] = this.addressCountryCode;
        data["phone"] = this.phone;
        data["token"] = this.token;
        data["PaymentMethodType"] = this.paymentMethodType;
        return data;
    }
}

export interface IIFrameSavePaymentMethodRequestDto {
    /** The token provided by the recaptcha widget */
    captchaToken?: string | undefined;
    /** Last 4 digits of card being used to pay */
    last4?: string;
    /** Visa, Mastercard, Discover, or Amex */
    cardType?: string;
    /** When the card expires (MMYY) */
    cardExpiry?: string;
    eCheckAccountType?: ECheckAccountTypeEnumDto;
    eCheckAccountOwnerType?: ECheckAccountOwnerTypeEnumDto;
    /** E-Check Account Number */
    eCheckAccountNumber?: string;
    /** E-Check Routing Number */
    eCheckRoutingNumber?: string;
    /** Full name */
    fullName?: string;
    /** Line 1 of the billing address fields */
    addressLine1?: string;
    /** Line 2 of the billing address fields */
    addressLine2?: string;
    /** Billing Address city */
    addressCity?: string;
    /** Billing Address state */
    addressState?: string;
    /** Billing address state code */
    addressStateCode?: string;
    /** Billing zip code */
    addressZip?: string;
    /** Billing address country */
    addressCountry?: string;
    /** Billing address ISO country code */
    addressCountryCode?: string;
    /** Address Phone number (e.g. (973) 552-2630) */
    phone?: string;
    /** CC Token */
    token?: string;
    paymentMethodType: PaymentMethodTypeEnumDto;

    [key: string]: any;
}

/** Response to updating a payment method */
export class IFrameSavePaymentMethodResponseDto implements IIFrameSavePaymentMethodResponseDto {
    /** The id of the new payment method */
    paymentMethodId?: number;
    /** Last 4 digits of the payment method */
    last4?: string;

    [key: string]: any;

    constructor(data?: IIFrameSavePaymentMethodResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentMethodId = _data["paymentMethodId"];
            this.last4 = _data["last4"];
        }
    }

    static fromJS(data: any): IFrameSavePaymentMethodResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IFrameSavePaymentMethodResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentMethodId"] = this.paymentMethodId;
        data["last4"] = this.last4;
        return data;
    }
}

/** Response to updating a payment method */
export interface IIFrameSavePaymentMethodResponseDto {
    /** The id of the new payment method */
    paymentMethodId?: number;
    /** Last 4 digits of the payment method */
    last4?: string;

    [key: string]: any;
}

export class PaymentConfigResponseDto implements IPaymentConfigResponseDto {
    defaultConfig?: PaymentConfigDto;
    configOverrides?: PaymentConfigDto[];

    [key: string]: any;

    constructor(data?: IPaymentConfigResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.defaultConfig = _data["defaultConfig"] ? PaymentConfigDto.fromJS(_data["defaultConfig"]) : <any>undefined;
            if (Array.isArray(_data["configOverrides"])) {
                this.configOverrides = [] as any;
                for (let item of _data["configOverrides"])
                    this.configOverrides!.push(PaymentConfigDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentConfigResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentConfigResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["defaultConfig"] = this.defaultConfig ? this.defaultConfig.toJSON() : <any>undefined;
        if (Array.isArray(this.configOverrides)) {
            data["configOverrides"] = [];
            for (let item of this.configOverrides)
                data["configOverrides"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaymentConfigResponseDto {
    defaultConfig?: PaymentConfigDto;
    configOverrides?: PaymentConfigDto[];

    [key: string]: any;
}

export class PaymentConfigDto implements IPaymentConfigDto {
    /** Whether or not this processor is enabled
True: The payment method(s) this processor supports will be usable
False: The payment method(s) this processor supports will not be displayed or usable
 */
    enabled!: boolean;
    /** The number of minutes the processor will allow the user to complete the payment */
    processorExpiryTime?: number;
    /** The number of seconds to wait when polling for changes to the cart hash */
    cartHashRefreshTime?: number;
    /** Unique identifier for this configuration to be used when attempting
to override the payment config for a subset of items in the cart.
 */
    configKey?: string;
    /** Convenience fee information that will override default convenience fee config */
    creditConfig?: PaymentConfigMethodOverrideDto;
    /** Convenience fee information that will override default convenience fee config */
    eCheckConfig?: PaymentConfigMethodOverrideDto;
    /** Whether or not we will calculate the convenience fee on our side
True: we will calculate (approximate) it ahead of time to display
False: the fee will only be calculated in the payment portal
 */
    convenienceFeeEnabled!: boolean;
    /** An alternate label to use in place of the default "Convenience Fee" */
    convenienceFeeLabel?: string;
    /** The message to display next to the convenience fee item (via the "i" icon) */
    convenienceFeeNote?: string;
    /** What format the rate is stored as (percent, flat, other) */
    convenienceFeeFormat?: string;
    /** The rate the convenience fee is charged at
Stored as a represetation matching the format
e.g. 3% would be 0.03, $50 would be 50
If the rate is more complex, use format "other" and do not fill this out
 */
    convenienceFeeRate?: number;
    /** Any additional data that is needed to be sent from the backend to frontend */
    additionalData?: { [key: string]: string; };

    [key: string]: any;

    constructor(data?: IPaymentConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.enabled = _data["enabled"];
            this.processorExpiryTime = _data["processorExpiryTime"];
            this.cartHashRefreshTime = _data["cartHashRefreshTime"];
            this.configKey = _data["configKey"];
            this.creditConfig = _data["creditConfig"] ? PaymentConfigMethodOverrideDto.fromJS(_data["creditConfig"]) : <any>undefined;
            this.eCheckConfig = _data["eCheckConfig"] ? PaymentConfigMethodOverrideDto.fromJS(_data["eCheckConfig"]) : <any>undefined;
            this.convenienceFeeEnabled = _data["convenienceFeeEnabled"];
            this.convenienceFeeLabel = _data["convenienceFeeLabel"];
            this.convenienceFeeNote = _data["convenienceFeeNote"];
            this.convenienceFeeFormat = _data["convenienceFeeFormat"];
            this.convenienceFeeRate = _data["convenienceFeeRate"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (<any>this.additionalData)![key] = _data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): PaymentConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["enabled"] = this.enabled;
        data["processorExpiryTime"] = this.processorExpiryTime;
        data["cartHashRefreshTime"] = this.cartHashRefreshTime;
        data["configKey"] = this.configKey;
        data["creditConfig"] = this.creditConfig ? this.creditConfig.toJSON() : <any>undefined;
        data["eCheckConfig"] = this.eCheckConfig ? this.eCheckConfig.toJSON() : <any>undefined;
        data["convenienceFeeEnabled"] = this.convenienceFeeEnabled;
        data["convenienceFeeLabel"] = this.convenienceFeeLabel;
        data["convenienceFeeNote"] = this.convenienceFeeNote;
        data["convenienceFeeFormat"] = this.convenienceFeeFormat;
        data["convenienceFeeRate"] = this.convenienceFeeRate;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (<any>data["additionalData"])[key] = (<any>this.additionalData)[key];
            }
        }
        return data;
    }
}

export interface IPaymentConfigDto {
    /** Whether or not this processor is enabled
True: The payment method(s) this processor supports will be usable
False: The payment method(s) this processor supports will not be displayed or usable
 */
    enabled: boolean;
    /** The number of minutes the processor will allow the user to complete the payment */
    processorExpiryTime?: number;
    /** The number of seconds to wait when polling for changes to the cart hash */
    cartHashRefreshTime?: number;
    /** Unique identifier for this configuration to be used when attempting
to override the payment config for a subset of items in the cart.
 */
    configKey?: string;
    /** Convenience fee information that will override default convenience fee config */
    creditConfig?: PaymentConfigMethodOverrideDto;
    /** Convenience fee information that will override default convenience fee config */
    eCheckConfig?: PaymentConfigMethodOverrideDto;
    /** Whether or not we will calculate the convenience fee on our side
True: we will calculate (approximate) it ahead of time to display
False: the fee will only be calculated in the payment portal
 */
    convenienceFeeEnabled: boolean;
    /** An alternate label to use in place of the default "Convenience Fee" */
    convenienceFeeLabel?: string;
    /** The message to display next to the convenience fee item (via the "i" icon) */
    convenienceFeeNote?: string;
    /** What format the rate is stored as (percent, flat, other) */
    convenienceFeeFormat?: string;
    /** The rate the convenience fee is charged at
Stored as a represetation matching the format
e.g. 3% would be 0.03, $50 would be 50
If the rate is more complex, use format "other" and do not fill this out
 */
    convenienceFeeRate?: number;
    /** Any additional data that is needed to be sent from the backend to frontend */
    additionalData?: { [key: string]: string; };

    [key: string]: any;
}

/** Payment identifier for the newly created payment */
export class StartPaymentResponseDto implements IStartPaymentResponseDto {
    /** Unique identifier for the payment */
    paymentIdentifier?: string;
    /** Redirect url for the payment */
    redirectUrl?: string | undefined;

    [key: string]: any;

    constructor(data?: IStartPaymentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): StartPaymentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new StartPaymentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

/** Payment identifier for the newly created payment */
export interface IStartPaymentResponseDto {
    /** Unique identifier for the payment */
    paymentIdentifier?: string;
    /** Redirect url for the payment */
    redirectUrl?: string | undefined;

    [key: string]: any;
}

/** Convenience fee amounts for each partition of the cart. */
export class ConvenienceFeeResponseDto implements IConvenienceFeeResponseDto {
    /** The convenience fee amounts for the groupings in the cart. */
    fees?: ConvenienceFeeDto[];

    [key: string]: any;

    constructor(data?: IConvenienceFeeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["fees"])) {
                this.fees = [] as any;
                for (let item of _data["fees"])
                    this.fees!.push(ConvenienceFeeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConvenienceFeeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConvenienceFeeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        return data;
    }
}

/** Convenience fee amounts for each partition of the cart. */
export interface IConvenienceFeeResponseDto {
    /** The convenience fee amounts for the groupings in the cart. */
    fees?: ConvenienceFeeDto[];

    [key: string]: any;
}

export class ConvenienceFeeDto implements IConvenienceFeeDto {
    /** The convenience fee amount */
    amount?: number;
    /** Key used for config overrides */
    configKey?: string;

    [key: string]: any;

    constructor(data?: IConvenienceFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.amount = _data["amount"];
            this.configKey = _data["configKey"];
        }
    }

    static fromJS(data: any): ConvenienceFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConvenienceFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["amount"] = this.amount;
        data["configKey"] = this.configKey;
        return data;
    }
}

export interface IConvenienceFeeDto {
    /** The convenience fee amount */
    amount?: number;
    /** Key used for config overrides */
    configKey?: string;

    [key: string]: any;
}

export class PaymentConfigMethodOverrideDto implements IPaymentConfigMethodOverrideDto {
    /** Whether or not this processor is enabled
True: The payment method(s) this processor supports will be usable
False: The payment method(s) this processor supports will not be displayed or usable
 */
    enabled!: boolean;
    /** The number of minutes the processor will allow the user to complete the payment */
    processorExpiryTime?: number;
    /** The number of seconds to wait when polling for changes to the cart hash */
    cartHashRefreshTime?: number;
    /** Whether or not we will calculate the convenience fee on our side
True: we will calculate (approximate) it ahead of time to display
False: the fee will only be calculated in the payment portal
 */
    convenienceFeeEnabled!: boolean;
    /** An alternate label to use in place of the default "Convenience Fee" */
    convenienceFeeLabel?: string;
    /** The message to display next to the convenience fee item (via the "i" icon) */
    convenienceFeeNote?: string;
    /** What format the rate is stored as (percent, flat, other) */
    convenienceFeeFormat?: string;
    /** The rate the convenience fee is charged at
Stored as a represetation matching the format
e.g. 3% would be 0.03, $50 would be 50
If the rate is more complex, use format "other" and do not fill this out
 */
    convenienceFeeRate?: number;
    /** The confirmation message displayed when a user attempts to pay with an E-Check. */
    eCheckConfirmation?: string;
    /** The disclaimer message displayed when a user attempts to save an E-Check payment method. */
    eCheckDisclaimer?: string;
    /** Determines whether or not dual entry of account and routing numbers are required when paying by E-Check. */
    requireDualEntryForECheck?: any;
    /** Any additional data that is needed to be sent from the backend to frontend */
    additionalData?: { [key: string]: string; };
    /** Whether or not credit cards can be saved to pay with later via tokenization
  True: we will allow the user to select to store the CC for later use in which case
      we will store a token for later use
  False: the user will not get the option to store their CC payment method
 */
    supportsTokenization?: boolean;
    /** If this is a test environment, this may be populated with a test trigger which will appear
on the UI to allow a tester to trigger certain scenarios with the payment processor.
 */
    testTriggers?: { [key: string]: string; };

    [key: string]: any;

    constructor(data?: IPaymentConfigMethodOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.enabled = _data["enabled"];
            this.processorExpiryTime = _data["processorExpiryTime"];
            this.cartHashRefreshTime = _data["cartHashRefreshTime"];
            this.convenienceFeeEnabled = _data["convenienceFeeEnabled"];
            this.convenienceFeeLabel = _data["convenienceFeeLabel"];
            this.convenienceFeeNote = _data["convenienceFeeNote"];
            this.convenienceFeeFormat = _data["convenienceFeeFormat"];
            this.convenienceFeeRate = _data["convenienceFeeRate"];
            this.eCheckConfirmation = _data["eCheckConfirmation"];
            this.eCheckDisclaimer = _data["eCheckDisclaimer"];
            this.requireDualEntryForECheck = _data["requireDualEntryForECheck"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (<any>this.additionalData)![key] = _data["additionalData"][key];
                }
            }
            this.supportsTokenization = _data["supportsTokenization"];
            if (_data["testTriggers"]) {
                this.testTriggers = {} as any;
                for (let key in _data["testTriggers"]) {
                    if (_data["testTriggers"].hasOwnProperty(key))
                        (<any>this.testTriggers)![key] = _data["testTriggers"][key];
                }
            }
        }
    }

    static fromJS(data: any): PaymentConfigMethodOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentConfigMethodOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["enabled"] = this.enabled;
        data["processorExpiryTime"] = this.processorExpiryTime;
        data["cartHashRefreshTime"] = this.cartHashRefreshTime;
        data["convenienceFeeEnabled"] = this.convenienceFeeEnabled;
        data["convenienceFeeLabel"] = this.convenienceFeeLabel;
        data["convenienceFeeNote"] = this.convenienceFeeNote;
        data["convenienceFeeFormat"] = this.convenienceFeeFormat;
        data["convenienceFeeRate"] = this.convenienceFeeRate;
        data["eCheckConfirmation"] = this.eCheckConfirmation;
        data["eCheckDisclaimer"] = this.eCheckDisclaimer;
        data["requireDualEntryForECheck"] = this.requireDualEntryForECheck;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (<any>data["additionalData"])[key] = (<any>this.additionalData)[key];
            }
        }
        data["supportsTokenization"] = this.supportsTokenization;
        if (this.testTriggers) {
            data["testTriggers"] = {};
            for (let key in this.testTriggers) {
                if (this.testTriggers.hasOwnProperty(key))
                    (<any>data["testTriggers"])[key] = (<any>this.testTriggers)[key];
            }
        }
        return data;
    }
}

export interface IPaymentConfigMethodOverrideDto {
    /** Whether or not this processor is enabled
True: The payment method(s) this processor supports will be usable
False: The payment method(s) this processor supports will not be displayed or usable
 */
    enabled: boolean;
    /** The number of minutes the processor will allow the user to complete the payment */
    processorExpiryTime?: number;
    /** The number of seconds to wait when polling for changes to the cart hash */
    cartHashRefreshTime?: number;
    /** Whether or not we will calculate the convenience fee on our side
True: we will calculate (approximate) it ahead of time to display
False: the fee will only be calculated in the payment portal
 */
    convenienceFeeEnabled: boolean;
    /** An alternate label to use in place of the default "Convenience Fee" */
    convenienceFeeLabel?: string;
    /** The message to display next to the convenience fee item (via the "i" icon) */
    convenienceFeeNote?: string;
    /** What format the rate is stored as (percent, flat, other) */
    convenienceFeeFormat?: string;
    /** The rate the convenience fee is charged at
Stored as a represetation matching the format
e.g. 3% would be 0.03, $50 would be 50
If the rate is more complex, use format "other" and do not fill this out
 */
    convenienceFeeRate?: number;
    /** The confirmation message displayed when a user attempts to pay with an E-Check. */
    eCheckConfirmation?: string;
    /** The disclaimer message displayed when a user attempts to save an E-Check payment method. */
    eCheckDisclaimer?: string;
    /** Determines whether or not dual entry of account and routing numbers are required when paying by E-Check. */
    requireDualEntryForECheck?: any;
    /** Any additional data that is needed to be sent from the backend to frontend */
    additionalData?: { [key: string]: string; };
    /** Whether or not credit cards can be saved to pay with later via tokenization
  True: we will allow the user to select to store the CC for later use in which case
      we will store a token for later use
  False: the user will not get the option to store their CC payment method
 */
    supportsTokenization?: boolean;
    /** If this is a test environment, this may be populated with a test trigger which will appear
on the UI to allow a tester to trigger certain scenarios with the payment processor.
 */
    testTriggers?: { [key: string]: string; };

    [key: string]: any;
}

/** Response to preparing a payment (but not submitting it) */
export class IFramePaymentPrepareResponseDto implements IIFramePaymentPrepareResponseDto {
    /** The token representing the payment. */
    paymentToken?: string;
    /** The total amount of the convenience fee. */
    convenienceFee?: number;
    /** The payment method type returned by the processor. */
    processorPaymentMethodType?: string;

    [key: string]: any;

    constructor(data?: IIFramePaymentPrepareResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentToken = _data["paymentToken"];
            this.convenienceFee = _data["convenienceFee"];
            this.processorPaymentMethodType = _data["processorPaymentMethodType"];
        }
    }

    static fromJS(data: any): IFramePaymentPrepareResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IFramePaymentPrepareResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentToken"] = this.paymentToken;
        data["convenienceFee"] = this.convenienceFee;
        data["processorPaymentMethodType"] = this.processorPaymentMethodType;
        return data;
    }
}

/** Response to preparing a payment (but not submitting it) */
export interface IIFramePaymentPrepareResponseDto {
    /** The token representing the payment. */
    paymentToken?: string;
    /** The total amount of the convenience fee. */
    convenienceFee?: number;
    /** The payment method type returned by the processor. */
    processorPaymentMethodType?: string;

    [key: string]: any;
}

export class FisPaymentDetailsRequestDto implements IFisPaymentDetailsRequestDto {
    /** The guid of the cart to generate details for */
    cartGuid!: string;
    /** The token returned from the captcha widget */
    captchaToken!: string | undefined;

    [key: string]: any;

    constructor(data?: IFisPaymentDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cartGuid = _data["cartGuid"];
            this.captchaToken = _data["captchaToken"];
        }
    }

    static fromJS(data: any): FisPaymentDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FisPaymentDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cartGuid"] = this.cartGuid;
        data["captchaToken"] = this.captchaToken;
        return data;
    }
}

export interface IFisPaymentDetailsRequestDto {
    /** The guid of the cart to generate details for */
    cartGuid: string;
    /** The token returned from the captcha widget */
    captchaToken: string | undefined;

    [key: string]: any;
}

/** The lineItems and userParts that need to be passed to the MultiPay iFrame */
export class FisPaymentDetailsResponseDto implements IFisPaymentDetailsResponseDto {
    /** The line items to be passed to the MultiPay iFrame for payment */
    lineItems?: FisLineItemDto[];
    /** A set of up to 6 user parts to be passed to the MultiPay iFrame for payment */
    userParts?: FisUserPartDto[];

    [key: string]: any;

    constructor(data?: IFisPaymentDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(FisLineItemDto.fromJS(item));
            }
            if (Array.isArray(_data["userParts"])) {
                this.userParts = [] as any;
                for (let item of _data["userParts"])
                    this.userParts!.push(FisUserPartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FisPaymentDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FisPaymentDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        if (Array.isArray(this.userParts)) {
            data["userParts"] = [];
            for (let item of this.userParts)
                data["userParts"].push(item.toJSON());
        }
        return data;
    }
}

/** The lineItems and userParts that need to be passed to the MultiPay iFrame */
export interface IFisPaymentDetailsResponseDto {
    /** The line items to be passed to the MultiPay iFrame for payment */
    lineItems?: FisLineItemDto[];
    /** A set of up to 6 user parts to be passed to the MultiPay iFrame for payment */
    userParts?: FisUserPartDto[];

    [key: string]: any;
}

/** A line item to be passed to the MultiPay iFrame for payment */
export class FisLineItemDto implements IFisLineItemDto {
    /** The amount (price) of the line item */
    amount?: number;
    /** The quantity of times this specific line item is to be paid for */
    quantity?: number;
    /** The description of the line item */
    name?: string;
    /** A set of up to 6 user parts to be passed to the MultiPay iFrame for payment */
    userParts?: FisUserPartDto[];

    [key: string]: any;

    constructor(data?: IFisLineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.name = _data["name"];
            if (Array.isArray(_data["userParts"])) {
                this.userParts = [] as any;
                for (let item of _data["userParts"])
                    this.userParts!.push(FisUserPartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FisLineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FisLineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["name"] = this.name;
        if (Array.isArray(this.userParts)) {
            data["userParts"] = [];
            for (let item of this.userParts)
                data["userParts"].push(item.toJSON());
        }
        return data;
    }
}

/** A line item to be passed to the MultiPay iFrame for payment */
export interface IFisLineItemDto {
    /** The amount (price) of the line item */
    amount?: number;
    /** The quantity of times this specific line item is to be paid for */
    quantity?: number;
    /** The description of the line item */
    name?: string;
    /** A set of up to 6 user parts to be passed to the MultiPay iFrame for payment */
    userParts?: FisUserPartDto[];

    [key: string]: any;
}

/** A user part to be passed to the MultiPay iFrame for payment */
export class FisUserPartDto implements IFisUserPartDto {
    /** The user part number (1-6) */
    number?: string;
    /** The value for the user part */
    value?: string;

    [key: string]: any;

    constructor(data?: IFisUserPartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.number = _data["number"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FisUserPartDto {
        data = typeof data === 'object' ? data : {};
        let result = new FisUserPartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["number"] = this.number;
        data["value"] = this.value;
        return data;
    }
}

/** A user part to be passed to the MultiPay iFrame for payment */
export interface IFisUserPartDto {
    /** The user part number (1-6) */
    number?: string;
    /** The value for the user part */
    value?: string;

    [key: string]: any;
}

export class NicVerifyPaymentStatusRequestDto implements INicVerifyPaymentStatusRequestDto {
    /** Token provided from the payment integrator */
    token!: string;
    /** Guid association with the cart */
    paymentIdentifier!: string;
    /** Status of the payment request as provided on the post-back URL */
    paymentStatus!: NicPaymentStatusEnum;

    [key: string]: any;

    constructor(data?: INicVerifyPaymentStatusRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): NicVerifyPaymentStatusRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new NicVerifyPaymentStatusRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface INicVerifyPaymentStatusRequestDto {
    /** Token provided from the payment integrator */
    token: string;
    /** Guid association with the cart */
    paymentIdentifier: string;
    /** Status of the payment request as provided on the post-back URL */
    paymentStatus: NicPaymentStatusEnum;

    [key: string]: any;
}

/** Response from backend of handling a postback from processor */
export class RedirectPaymentProcessorPaymentResponseDto implements IRedirectPaymentProcessorPaymentResponseDto {
    /** Status of the payment request */
    paymentStatus!: any;
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    /** Unique identifier for the cart. */
    cartGuid?: string;

    [key: string]: any;

    constructor(data?: IRedirectPaymentProcessorPaymentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentStatus = _data["paymentStatus"];
            this.emailAddress = _data["emailAddress"];
            this.cartGuid = _data["cartGuid"];
        }
    }

    static fromJS(data: any): RedirectPaymentProcessorPaymentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectPaymentProcessorPaymentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentStatus"] = this.paymentStatus;
        data["emailAddress"] = this.emailAddress;
        data["cartGuid"] = this.cartGuid;
        return data;
    }
}

/** Response from backend of handling a postback from processor */
export interface IRedirectPaymentProcessorPaymentResponseDto {
    /** Status of the payment request */
    paymentStatus: any;
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    /** Unique identifier for the cart. */
    cartGuid?: string;

    [key: string]: any;
}

/** Response from NicController of handling a postback from NIC */
export class NicVerifyPaymentStatusResponseDto extends RedirectPaymentProcessorPaymentResponseDto implements INicVerifyPaymentStatusResponseDto {
    /** Status of the payment request */
    paymentStatus!: NicPaymentStatusEnum;

    [key: string]: any;

    constructor(data?: INicVerifyPaymentStatusResponseDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): NicVerifyPaymentStatusResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new NicVerifyPaymentStatusResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentStatus"] = this.paymentStatus;
        super.toJSON(data);
        return data;
    }
}

/** Response from NicController of handling a postback from NIC */
export interface INicVerifyPaymentStatusResponseDto extends IRedirectPaymentProcessorPaymentResponseDto {
    /** Status of the payment request */
    paymentStatus: NicPaymentStatusEnum;

    [key: string]: any;
}

/** Response containing session token. */
export class SessionTokenResponseDto implements ISessionTokenResponseDto {
    /** The generated token. Will be null if token could not be generated. */
    token?: string;

    [key: string]: any;

    constructor(data?: ISessionTokenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SessionTokenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTokenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        return data;
    }
}

/** Response containing session token. */
export interface ISessionTokenResponseDto {
    /** The generated token. Will be null if token could not be generated. */
    token?: string;

    [key: string]: any;
}

export enum NicPaymentStatusEnum {
    Success = "success",
    Failure = "failure",
    Duplicate = "duplicate",
    Cancelled = "cancelled",
}

export class RedirectVerifyPaymentStatusRequestDto implements IRedirectVerifyPaymentStatusRequestDto {
    /** Ref provided from the payment integrator */
    ref?: string;
    /** Unique identifier association with the payment */
    paymentIdentifier!: string;
    /** Status of the payment request as provided on the post-back URL */
    paymentStatus!: RedirectPaymentStatusEnum;

    [key: string]: any;

    constructor(data?: IRedirectVerifyPaymentStatusRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.ref = _data["ref"];
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): RedirectVerifyPaymentStatusRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectVerifyPaymentStatusRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["ref"] = this.ref;
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IRedirectVerifyPaymentStatusRequestDto {
    /** Ref provided from the payment integrator */
    ref?: string;
    /** Unique identifier association with the payment */
    paymentIdentifier: string;
    /** Status of the payment request as provided on the post-back URL */
    paymentStatus: RedirectPaymentStatusEnum;

    [key: string]: any;
}

/** Response from backend of handling a postback from processor */
export class RedirectVerifyPaymentStatusResponseDto implements IRedirectVerifyPaymentStatusResponseDto {
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    /** True if the payment succeeded, false otherwise */
    responseSuccess!: any;
    /** The error message corresponding to a failed payment */
    responseMessage?: string;

    [key: string]: any;

    constructor(data?: IRedirectVerifyPaymentStatusResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.emailAddress = _data["emailAddress"];
            this.responseSuccess = _data["responseSuccess"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): RedirectVerifyPaymentStatusResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectVerifyPaymentStatusResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["emailAddress"] = this.emailAddress;
        data["responseSuccess"] = this.responseSuccess;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

/** Response from backend of handling a postback from processor */
export interface IRedirectVerifyPaymentStatusResponseDto {
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    /** True if the payment succeeded, false otherwise */
    responseSuccess: any;
    /** The error message corresponding to a failed payment */
    responseMessage?: string;

    [key: string]: any;
}

export class FisVerifyPaymentRequestDto implements IFisVerifyPaymentRequestDto {
    /** The cart GUID of the cart to verify payment for */
    cartGuid!: string;
    /** The idendifier of the payment to verify */
    paymentIdentifier!: string;
    /** The payment ID returned from the MultiPay iFrame */
    paymentId!: string | undefined;
    /** The email address entered during payment, will be used to send a receipt */
    email?: string;
    /** Last 4 digits of card being used to pay */
    last4?: string;
    /** Values returned from FIS, examples are -- Visa, Mastercard, Discover, or American Express */
    cardType?: string;
    /** Mix of values from FIS, will be either the same as cardType, or "Debit" or "Bank" */
    processorPaymentMethodType?: string;

    [key: string]: any;

    constructor(data?: IFisVerifyPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cartGuid = _data["cartGuid"];
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.paymentId = _data["paymentId"];
            this.email = _data["email"];
            this.last4 = _data["last4"];
            this.cardType = _data["cardType"];
            this.processorPaymentMethodType = _data["processorPaymentMethodType"];
        }
    }

    static fromJS(data: any): FisVerifyPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FisVerifyPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cartGuid"] = this.cartGuid;
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["paymentId"] = this.paymentId;
        data["email"] = this.email;
        data["last4"] = this.last4;
        data["cardType"] = this.cardType;
        data["processorPaymentMethodType"] = this.processorPaymentMethodType;
        return data;
    }
}

export interface IFisVerifyPaymentRequestDto {
    /** The cart GUID of the cart to verify payment for */
    cartGuid: string;
    /** The idendifier of the payment to verify */
    paymentIdentifier: string;
    /** The payment ID returned from the MultiPay iFrame */
    paymentId: string | undefined;
    /** The email address entered during payment, will be used to send a receipt */
    email?: string;
    /** Last 4 digits of card being used to pay */
    last4?: string;
    /** Values returned from FIS, examples are -- Visa, Mastercard, Discover, or American Express */
    cardType?: string;
    /** Mix of values from FIS, will be either the same as cardType, or "Debit" or "Bank" */
    processorPaymentMethodType?: string;

    [key: string]: any;
}

export enum RedirectPaymentStatusEnum {
    Success = "success",
    Failure = "failure",
    Duplicate = "duplicate",
    Cancelled = "cancelled",
}

/** Status of a payment. */
export enum PaymentStatusEnumDto {
    PreProcessing = "PreProcessing",
    Processing = "Processing",
    Processed = "Processed",
    ProcessingFailed = "ProcessingFailed",
    Failed = "Failed",
    Posting = "Posting",
    Posted = "Posted",
    PostingFailed = "PostingFailed",
    PendingReview = "PendingReview",
    Cancelled = "Cancelled",
    Refunded = "Refunded",
    Finalized = "Finalized",
}

/** Supported payment method types */
export enum PaymentMethodTypeEnumDto {
    CreditCard = "CreditCard",
    ECheck = "ECheck",
    Undetermined = "Undetermined",
}

/** Allowed Account Types for EChecks */
export enum ECheckAccountTypeEnumDto {
    Checking = "Checking",
    Savings = "Savings",
}

/** Allowed Account Ownership Types for EChecks */
export enum ECheckAccountOwnerTypeEnumDto {
    Personal = "Personal",
    Business = "Business",
}

export class ErrorDto implements IErrorDto {
    /** Error message to display to the user */
    errorMessage!: string;
    /** Random number to help correlate the error log with what the user sees.
Prefix "S" is for Server error; "C" is for Client error.
 */
    errorNumber!: string;
    /** Error def identifying the error */
    errorDef!: string;
    /** Error details for troubleshooting/development */
    errorDetails?: string;
    /** Prompt the user with a modal dialog with this message. */
    prompt?: boolean;

    [key: string]: any;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.errorMessage = _data["errorMessage"];
            this.errorNumber = _data["errorNumber"];
            this.errorDef = _data["errorDef"];
            this.errorDetails = _data["errorDetails"];
            this.prompt = _data["prompt"];
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["errorMessage"] = this.errorMessage;
        data["errorNumber"] = this.errorNumber;
        data["errorDef"] = this.errorDef;
        data["errorDetails"] = this.errorDetails;
        data["prompt"] = this.prompt;
        return data;
    }
}

export interface IErrorDto {
    /** Error message to display to the user */
    errorMessage: string;
    /** Random number to help correlate the error log with what the user sees.
Prefix "S" is for Server error; "C" is for Client error.
 */
    errorNumber: string;
    /** Error def identifying the error */
    errorDef: string;
    /** Error details for troubleshooting/development */
    errorDetails?: string;
    /** Prompt the user with a modal dialog with this message. */
    prompt?: boolean;

    [key: string]: any;
}

export class PaymentIntegrationException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isPaymentIntegrationException = true;

    static isPaymentIntegrationException(obj: any): obj is PaymentIntegrationException {
        return obj.isPaymentIntegrationException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new PaymentIntegrationException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}